import { sampleSize } from "lodash";
import { AssetSuggestion, MultipleAssetResponse } from "../@types/Asset";
import { AssetDetails } from "../@types/Posts";
import CacheService from "../services/cache/CacheService";
import { suggestions, walletSuggestions } from "./data/assets";
import { getMultiple } from "../services/asset";

export default function useAssets() {
  /**
   * Get random suggestions from local assets data.
   */
  function handleGetSuggestions(qnt: number): AssetSuggestion[] {
    const actualSize = suggestions.length;
    if (qnt > actualSize) {
      throw new Error(
        `you requested qnt of suggestions that are bigger than max, actual existing suggestions is: ${actualSize}`
      );
    }

    return sampleSize(suggestions, qnt);
  }

  function handleGetAllWalletSuggestions(): AssetSuggestion[] {
    return walletSuggestions;
  }

  function handleGetFromCache(encodedId: string): AssetDetails | null {
    const cacheService = new CacheService();

    return cacheService.get<AssetDetails>(encodedId, true);
  }

  function handleSetOnCache(encodedId: string, data: AssetDetails): boolean {
    const cacheService = new CacheService();

    return cacheService.set(encodedId, JSON.stringify(data), 2880);
  }

  function getAssetListData(
    assets: string
  ): Promise<MultipleAssetResponse | null> {
    return getMultiple(assets);
  }

  return {
    getSuggestions: handleGetSuggestions,
    getFromCache: handleGetFromCache,
    setOnCache: handleSetOnCache,
    getAssetListData,
    getWalletSuggestions: handleGetAllWalletSuggestions,
  };
}
